import { render } from "./TieBossAtvsHome.vue?vue&type=template&id=8dd64f3c"
import script from "./TieBossAtvsHome.vue?vue&type=script&lang=js"
export * from "./TieBossAtvsHome.vue?vue&type=script&lang=js"

import "./TieBossAtvsHome.vue?vue&type=style&index=0&id=8dd64f3c&lang=scss"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__